import { useLayoutEffect, useMemo, useRef } from 'react';
import { themeGetColor } from '@pocketlaw/tetris';
import { CanvasLayer } from '../../CanvasLayer';
import { TextLayer } from '../../TextLayer';
import { useStrictPDFData } from '../../usePDFData';
import { OuterPage, Page } from './styled';
export function Item(props) {
    const { page, pageNumber, zoom, zoomRef } = props;
    const { scale, spacing, setPageRef } = useStrictPDFData();
    const pageRef = useRef(null);
    const viewport = useMemo(() => page.getViewport({ scale }), [page, scale]);
    const pageHeight = viewport.height * zoom;
    const pageWidth = viewport.width * zoom;
    useLayoutEffect(() => {
        if (pageRef.current) {
            setPageRef(pageNumber, pageRef.current);
            if (pageNumber === 1) {
                zoomRef.current = pageRef.current;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<OuterPage $height={pageHeight} $width={pageWidth} $spacing={spacing} $borderColor={themeGetColor('border.100', 0.65)}>
      <Page $zoom={zoom} ref={pageRef}>
        <CanvasLayer page={page} scale={scale}/>
        <TextLayer page={page} scale={scale}/>
      </Page>
    </OuterPage>);
}
